<template>
  <handbook-list title="杂草手册" kindLabel="杂草" :api="api" />
</template>
<script>
import { weedApi } from '@/api/plantProtect'
import HandbookList from '../handbook/HandbookList.vue'
export default {
  name: 'WeedHandbook',
  components: { HandbookList },
  data() {
    return { api: weedApi }
  },
}
</script>
